import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-app-collaborator-list',
  templateUrl: './app-collaborator-list.component.html',
  styleUrls: ['./app-collaborator-list.component.scss'],
})
export class AppCollaboratorListComponent extends BaseListCtl {
  public appId: number = 0;
  public activeIndex!: Number | null;
  public copied = false;
  public userAppUrl: string = '';
  public applications: any = [];
  public users: any = [];
  public applicationlist: any = [];
  public applicationRoles: any = [];
  public selectApp: any = undefined;
  public editor: string = '';
  public userLogin: any = null;

  roles: string[] = ['Guest', 'Reporter', 'Developer', 'Maintainer'];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.collaborator'), locator, route);
    let _self = this;
    _self.appId = Number(route.snapshot.paramMap.get('appId'));
    _self.form['applicationId'] = 0;
    let contextPath = _self.locator.config.get('CONTEXT_PATH');
    if (contextPath) {
      let keySuffix = contextPath + '-';
      let loginId = localStorage.getItem(keySuffix + 'loginId');
      if (loginId !== null) {
        _self.userLogin = loginId;
        _self.form.searchParams['loginId'] = loginId;
      }
    }

    locator.config
      .getProperty('USER_APP_SERVER_URL')
      .then((property: string) => {
        _self.userAppUrl = property;
      });
  }

  /**
   * Populate form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.userId = data.userId;
    form.userFirstname = data.userFirstname;
    form.role = data.role;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
  }

  /**
   * Override on init method
   */
  override ngOnInit() {
    this.preload();
    this.search();
    this.getApplications();
    this.getUsers();
  }

  /**
   * override search method
   * @param callback
   */
  override search(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: string) => {
        let url = _self.api.search + '/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data;
              if (_self.applicationlist.length == 0) {
                _self.applicationlist = res.result.data;
              }
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  /**
   * Contains applications
   */
  getApplications() {
    let _self = this;
    // get applications
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        console.log('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  /**
   * Contains users
   */
  getUsers() {
    let _self = this;
    // get users
    let url = this.locator.getEndpoint('endpoint.user') + '/search/0';
    this.locator.http.post(url, {}, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.users = res.result.data;
    });
  }

  /**
   * Get usecase attributes
   * @param id
   */
  getApplicationRoles() {
    let _self = this;
    let url =
      _self.endpoint + '/application-roles/' + _self.form.data['applicationId'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationRoles = res.result.data;
    });
  }

  /**
   * Go to
   * @param id
   */
  goto(id: number) {
    this.forward('api/' + id);
  }

  /**
   * Copy app URL to clipboard
   * @param app
   * @param event
   * @param activeIndex
   */
  copyAppURL(app: any, event: any, activeIndex: any): void {
    event.preventDefault();
    this.activeIndex = activeIndex;
    const url = this.userAppUrl + app['orgId'] + '.' + app['id'];

    // Use Clipboard API to copy the URL
    navigator.clipboard.writeText(url).then(
      () => {
        this.copied = true; // Show the tooltip
        setTimeout(
          () => ((this.copied = false), (this.activeIndex = null)),
          3000
        ); // Hide after 2 seconds
      },
      (err) => {
        console.error('Failed to copy URL: ', err);
      }
    );
  }

  /**
   * Set App
   * @param app
   * @param edit
   */
  setApp(app: any, edit: string) {
    this.selectApp = app;
    this.editor = edit;
  }

  /**
   *
   * @param app
   * @param event
   */
  getAppURL(app: any, event: any) {
    event.preventDefault();
    var _self = this;
    const url = _self.userAppUrl + app['orgId'] + '.' + app['id'];
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  /**
   * go to urules
   * @param id
   */
  gotourules(id: number) {
    this.forward('rules/' + id);
  }

  /**
   * Change collaborator status
   * @param id
   * @param status
   */
  public changeStatus(id: number, status: string) {
    let _self = this;
    _self.form.error = [];
    _self.form.message = '';
    let url =
      this.locator.getEndpoint('endpoint.collaborator') +
      '/changestatus/' +
      id +
      '/' +
      status;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        _self.form.message = 'Status is updated';
        _self.form.list.forEach((e: any) => {
          if (e.id === id) {
            e.status = res.result.data.status;
          }
        });
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  /**
   * filter application names from applist
   * @param list
   * @returns
   */
  public getUniqueApplicationNames(): any[] {
    let _self = this;
    if (!_self.applicationlist) return [];
    const uniqueNames = new Set();
    return _self.applicationlist.filter((item: any) => {
      if (!uniqueNames.has(item.applicationName)) {
        uniqueNames.add(item.applicationName);
        return true;
      }
      return false;
    });
  }

  /**
   * Override reset search form for user login
   */
  override resetSearchForm() {
    super.resetSearchForm();
    this.form.searchParams['loginId'] = this.userLogin;
  }

  isExpanded = false;
  toggleSearch(): void {
    this.isExpanded = !this.isExpanded;
  }
}
